document.addEventListener('DOMContentLoaded', function () {
  function buildReviewAccordion() {
    const reviewsEl = document.getElementById('judgeme_product_reviews');
    if (!reviewsEl) return;

    const parent = reviewsEl.parentNode;
    if (!parent) return;

    const placeholder = document.createElement('div');
    parent.insertBefore(placeholder, reviewsEl);

    const avgEl = reviewsEl.querySelector('[data-average-rating]');
    const countEl = reviewsEl.querySelector('[data-number-of-reviews]');

    const avg = avgEl ? parseFloat(avgEl.getAttribute('data-average-rating')) : null;
    const count = countEl ? parseInt(countEl.getAttribute('data-number-of-reviews')) : null;

    function buildStars(rating) {
      if (!rating) return '';
      let stars = '';
      for (let i = 1; i <= 5; i++) {
        if (rating >= i) {
          stars += '<span style="color:#f5a623;">★</span>';
        } else if (rating >= i - 0.5) {
          stars += '<span style="color:#f5a623; opacity:0.5;">★</span>';
        } else {
          stars += '<span style="color:#ccc;">★</span>';
        }
      }
      return '<span style="margin-left:8px; vertical-align:middle;">' + stars + '</span>';
    }

    const starsHtml = avg ? buildStars(avg) : '';
    const countHtml = count
      ? '<span style="font-size:0.85em; margin-left:6px; font-weight:normal;">(' + count + '件)</span>'
      : '';

    const disclosure = document.createElement('accordion-disclosure');
    disclosure.classList.add('accordion');

    const details = document.createElement('details');
    details.classList.add('accordion__disclosure', 'group');
    details.setAttribute('aria-expanded', 'false');

    const summary = document.createElement('summary');
    summary.innerHTML =
      '<span class="accordion__toggle h6">' +
        '<span>レビュー' + starsHtml + countHtml + '</span>' +
        '<span class="animated-plus group-expanded:rotate" aria-hidden="true"></span>' +
      '</span>';

    const content = document.createElement('div');
    content.classList.add('accordion__content');

    // IDは一切触らず、reviewsElの直前にアンカーを置く
    const scrollAnchor = document.createElement('div');
    scrollAnchor.style.cssText = 'display:block; height:0; overflow:hidden; pointer-events:none;';
    content.appendChild(scrollAnchor);
    content.appendChild(reviewsEl); // IDそのまま維持

    details.appendChild(summary);
    details.appendChild(content);
    disclosure.appendChild(details);

    // アコーディオン自体にもIDを付けてスクロール対象にする
    disclosure.setAttribute('data-reviews-anchor', 'true');

    parent.replaceChild(disclosure, placeholder);

    // Judge.meのスクロール後にタイトルが見えるようscroll-margin-topを設定
    reviewsEl.style.scrollMarginTop = '+500px';
  }

  const target = document.getElementById('judgeme_product_reviews');
  if (!target) return;

  if (target.querySelector('[data-average-rating]')) {
    buildReviewAccordion();
    return;
  }

  const observer = new MutationObserver(function (mutations, obs) {
    if (target.querySelector('[data-average-rating]')) {
      obs.disconnect();
      buildReviewAccordion();
    }
  });

  observer.observe(target, { childList: true, subtree: true });
});
